import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Hero from '@/components/Hero'
import Summary from '@/components/Summary'
import { Columns } from '@/components/Article/style.css'
import { Content } from '@/components/Rankings/style.css'
import { Link } from 'gatsby'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Ranking de universidades chilenas 2021"
      keywords={[
        `La Tercera`,
        `Ranking Universidades chilenas 2021`,
        `Ranking Universidades`,
      ]}
    />
    <Hero />
    <Summary />

    <div className="container max-w-5xl mx-auto">
      <Content>
        <h1 className="text-center">
          <strong>Radiografía</strong> a las casas de estudio
        </h1>
        <Columns>
          <p>
            Conocer los avances de las universidades en los últimos 12 meses, no
            sólo es de interés de los alumnos, también lo es para las familias
            de los futuros profesionales y para los planteles del país, pues en
            una publicación reunimos los principales indicadores que son medidos
            por la Servicio de Información de la Educación Superior (SIES), del
            Mineduc, que es el encargado de sistematizar y transparentar el
            trabajo que realizan las instituciones de educación terciaria.{' '}
          </p>

          <p>
            Chile tiene un sistema joven, dinámico y que avanza de la mano del
            Estado hacia el aseguramiento de la calidad. La nueva Ley de
            Educación Superior vino a barajar las cartas del naipe,
            estableciendo nuevas exigencias, entre ellas la obligatoriedad de la
            acreditación.{' '}
          </p>

          <p>
            En enero de 2019 en el país existían 60 planteles, hoy son 52. De
            los cuales, 45 cuentan con acreditación, mientras que otros cinco
            tienen hasta 2025 para lograr esta certificación, en todo caso, si
            sus proyectos académicos no cumplen con los requisitos, pasan a ser
            supervisados por del Consejo Nacional de Educación (CNED), entidad
            que acompaña el proceso durante otros tres años, solo tras ello, la
            Subsecretaría de Educación puede solicitar un proceso de cierre. En
            este grupo se encuentran las universidades Gabriela Mistral, de
            Aconcagua, del Alba, ex Pedro de Valdivia, Miguel de Cervantes y
            Bolivariana.{' '}
          </p>

          <p>
            Y si bien no están acreditadas aún, pues no cuentan con generaciones
            de egresados, las universidades estatales de Aysén y de O'Higgins
            muestran indicadores que superan a las instituciones que se
            encuentran en la parte baja del Ranking de Universidades. Hay otras
            universidades, como La República y de Los Leones que no pueden
            recibir alumnos en 2021, ya que mientras la primera tiene un cierre
            decretado, la segunda está en un proceso interno de
            reestructuración. Los resultados de esta nueva versión del ranking
            siguen manteniendo en el liderato a las universidades Católica, de
            Chile y de Concepción. La novedad es que este año ingresa al décimo
            lugar la U. de La Frontera, la que por primera vez está en el Top
            10.
          </p>
        </Columns>
      </Content>
    </div>
  </Layout>
)

export default IndexPage
